import { render, staticRenderFns } from "./DayTypeForm.vue?vue&type=template&id=2bb03498"
import script from "./DayTypeForm.vue?vue&type=script&lang=js"
export * from "./DayTypeForm.vue?vue&type=script&lang=js"
import style0 from "./DayTypeForm.vue?vue&type=style&index=0&id=2bb03498&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports